import State from "ducks/state"
import {connect} from "react-redux"

export const mapStateToProps = (state: State, props) => {
    const {template} = state

    return {templating: template, props}
}

export default connect(mapStateToProps)
